module.exports = __webpack_public_path__ + "static/media/coralteam.412f2ce8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/coralteam.webp
// module id = 801
// module chunks = 0